module.exports = __webpack_public_path__ + "media/images/prizeBox__bg--desktop-d28a80ab5455a6659ebfb308fd5e5f21.jpg";